/**
@flow strict-local
@format
*/

export default {
  Heading: {
    fontWeight: 'bold',
    large: { fontSize: 30, lineHeight: 40 },
    medium: { fontSize: 22, lineHeight: 30 },
    small: { fontSize: 18, lineHeight: 24 },
  },
};
